import styled from '@emotion/styled';

import { Separator } from '@/shared/design-system';

export const FieldsDivider = styled(Separator)({
  alignSelf: 'auto',
});

export const RegisteredUserSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
}));

export const RegisteredUserCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
  padding: theme.spacing[16],
  borderRadius: theme.radius[12],
  backgroundColor: theme.colors.background.overlay,
}));

export const RegisteredUserIdentity = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[12],
  minWidth: 0,
}));

export const RegisteredUserText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[4],
  minWidth: 0,
}));

export const RegisteredUserHeadshot = styled('img')(({ theme }) => ({
  width: 40,
  height: 40,
  flexShrink: 0,
  borderRadius: theme.radius.full,
  objectFit: 'cover',
}));

export const RegisteredUserLinks = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[8],
}));
